export enum LifeActionType {
    PAGINATE_LIVES = 'paginate_lives',
}